import { render, staticRenderFns } from "./BgqwPage15.vue?vue&type=template&id=ed60eac4"
import script from "./BgqwPage15.vue?vue&type=script&lang=js"
export * from "./BgqwPage15.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports